<template>
  <main class="p-0 flex flex-col relative">
    <section id="head" class="flex flex-row justify-between" :class="{ 'border-bottom': visible }" >
      <div class="mx-8 my-4 flex gap-x-3 items-center">
        <img
        src="@/assets/Iconography/market/MarketIcon.svg"
        alt="Market Icon"
        />
        <div class="text-left">
          <span class="text-xl font-bold text-black">{{
            data[appName].name
          }}</span>
          <p>{{ data[appName]["sub-head"] }}</p>
        </div>
      </div>
      <div class="flex justify-self-end self-center pr-10 cursor-pointer flex-row gap-1" @click="toggleVisibility" > App Details
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#b8c2cc" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-play-circle" v-if="visible">
    <circle cx="12" cy="12" r="10" />
    <polygon points="10 9 15 12 10 15" fill="white" transform="rotate(-90, 12, 12)" />
    </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#b8c2cc" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-play-circle" v-else>
    <circle cx="12" cy="12" r="10" />
    <polygon points="11 9 15 12 11 15" fill="white" transform="rotate(90, 12, 12)"/>
  </svg>
      </div>
      <!-- <span class="decorative-circle-right" />
        <span class="decorative-circle-left" /> -->
    </section>
    <section class="border-bottom" v-if="visible">
      <div class="my-4 bg-gray-100 py-3 mx-5 pb-10 rounded-lg ">
        <div class="text-xl font-bold text-black mx-8 py-3">About app</div>
        <p
          id="app-description"
          class="overflow-y-scroll ml-8 pr-8 scrollbarWidth limited-height"
        >
          {{ data[appName]["app-description"] }}
        </p>
        <!-- <span class="decorative-circle-right" />
          <span class="decorative-circle-left" /> -->
        <div class="relative flex flex-row mx-8 my-4  bottom-0 gap-x-10" v-if="visible">
          <span class="flex gap-x-2">
            <p>Price:</p>
        <span class="font-bold text-black">{{ data[appName]["price"] }}</span>
      </span>
      <span class="flex gap-x-2">
        <p>Published By:</p>
        <span class="font-bold text-black">{{
          data[appName]["published-by"]
        }}</span>
      </span>
      <span class="flex gap-x-2">
        <p>Category:</p>
        <span class="font-bold text-black">{{
          data[appName]["category"]
        }}</span>
      </span>
      <span class="flex gap-x-2">
        <p>Help and Support:</p>
        <span class="font-bold text-black">{{
          data[appName]["help-support"]
        }}</span>
      </span>
    </div>
        </div>
  </section>
  </main>
</template>

<script>
import data from "@/data/data.json";

export default {
  data() {
    return {
      data,
      visible: false,

    };
  },
  props: {
    appName: String,
  },

  methods: {
    toggleVisibility() {
      this.visible = !this.visible;
    }
  }
};

</script>

<style lang="scss" scoped>
.height-100px {
  height: 100px;
}
.bg-gray-100{
  background:#f3f4f8;
}
.decorative-circle-right {
  background-color: #f3f4f5;
  position: absolute;
  padding: 10px;
  right: -10px;
  bottom: -10px;
  border-radius: 50%;
}
.decorative-circle-left {
  background-color: #f3f4f5;
  position: absolute;
  padding: 10px;
  left: -10px;
  bottom: -10px;
  border-radius: 50%;
}
.border-bottom {
  border-bottom: 1px dashed rgb(183, 183, 183);
}
.limited-height {
  max-height: 70vh;
}

.bottom-4 {
  bottom: 4px;
}
.negative-top-right-7 {
  top: -7px;
  right: -7px;
}
.border-large-rounded {
  border-radius: 50%;
}
// on hover on this class
.border-large-rounded:hover {
  cursor: pointer;
}
.semi-white-bg {
  background-color: #ecececef;
}
.border-gray {
  border: 2px solid #d2d3d3;
  // border-color: #D2D3D3;
}
.scrollbarWidth::-webkit-scrollbar {
  width: 4px;
}
// .scrollbarWidth::-webkit-scrollbar-track {
// //   -webkit-box-shadow: inset 0 0 6px rgba(41, 39, 39, 0.3);
//   border-radius: 10px;
// }
.scrollbarWidth::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 20px rgb(225, 225, 225);
}
.background-white {
  background-color: #ffffff;
}

.preview_images {
  width: 65px !important;
  height: 65px !important;
}

.coupons-text:hover {
  color: rgb(107, 107, 107) !important;
  cursor: pointer;
}

.common {
  &__box {
    padding: 2em;
    border-radius: 10px;
    background: #ffffff;
    box-shadow: 0px 30px 40px 20px rgba(99, 132, 227, 0.1);
  }
}

.form__container {
  .font__large {
    font-size: 1.5em;
  }
  .font__normal {
    font-size: 1.25em;
  }
  .font__small {
    font-size: 1em;
  }

  h2 {
    color: #101828;
    font-weight: 600;
  }
  h3 {
    color: #798ba0;
    font-weight: 500;
  }

  .product__type {
    display: grid;
    place-content: start;
    justify-content: start;
    grid-auto-flow: column;
    gap: 1em;
    margin: 0.5em 0em;

    &__item {
      position: relative;
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      place-content: start;

      input {
        appearance: none;
        height: 15px;
        width: 15px;
        border: solid 1px #f29300;
        border-color: #f29300;
        border-radius: 50%;
        background-color: #ffffff;
        margin-right: 0.3em;
        display: grid;
        place-content: center;
        position: relative;
        cursor: pointer;
      }

      input:before {
        content: " ";
        position: absolute;
        z-index: 1;
        top: 1px;
        bottom: 1px;
        left: 1px;
        right: 1px;
        border-radius: 50%;
        border: 2px solid #ffffff;
      }

      input:checked {
        background-color: #f29300;
      }

      label {
        color: #798ba0;
        font-weight: 500;
        padding-top: 0.25em;
        cursor: pointer;
      }
    }
  }

  .product__model {
    display: grid;
    place-content: start;
    grid-auto-flow: row;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    margin: 0.5em 0em;

    label {
      color: #363939;
      font-weight: 500;
      margin-bottom: 0.5em;
    }

    select {
      color: #8e9090;
      font-weight: 500;
      padding: 1em;
      border-radius: 0.3em;
      border: solid 1px #8e9090;
      background-color: #ffffff;
      grid-column: span 1 / span 1;
      margin-bottom: 0.5em;

      option {
        color: #363939;
      }
    }

    caption {
      color: #57595a;
      font-weight: 400;
      margin: 0.3em 0em;
      padding: 0em;
    }
  }

  .product__upload {
    margin: 0.5em 0em;
    span {
      color: #98a2b3;
    }

    label {
      color: #363939;
      font-weight: 500;
      margin-bottom: 1em;
    }

    .upload__box {
      border: dashed 1px #d2d3d3;
      display: grid;
      place-content: center;
      justify-content: center;
      padding: 1em 0em;
      cursor: pointer;

      input[type="file"] {
        left: 0;
        top: 0;
        opacity: 0;
        cursor: pointer;
      }

      img {
        width: 25px;
        height: 25px;
        place-self: center;
        margin-bottom: 0.8em;
      }

      label {
        color: #363939;
        font-weight: 000;
        text-align: center;
        padding: 0em;
      }

      caption {
        color: #57595a;
        font-weight: 400;
        text-align: center;
        padding: 0em;

        a {
          color: #1681ec;
          padding: 0em;
        }
      }
    }
  }

  button {
    background-color: #f2c046;
    color: #fff;
    padding: 0.8em;
    border-radius: 0.3em;
    border-style: none;
    margin-top: 2em;
    font-weight: 600;
  }
}

// .right__container {
//   width: 65%;
//   height: 90vh;
//   .market__banner {
//     background: url(../../../../assets/images/marketplace/market-header.svg)
//       no-repeat;
//     background-size: cover;
//     border-radius: 6px;
//   }

//   .product__card {
//     border: 2px solid #eaecf0;
//     border-radius: 8px;
//     width: 32% !important;
//     x &__img {
//       border-radius: 8px;
//     }
//     h5 {
//       color: #667085 !important;
//     }
//   }
// }

@media only screen and (max-width: 768px) {
  .right__container {
    width: 100%;
  }
}
</style>
